module.exports = __webpack_public_path__ + "static/yildiz-entegre-icon-13e0a610b569766d0aa596cb360ad287.png";